import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";
import CropImageListImagesScreen from "./CropImageListImagesScreen";

function CropImagesMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || {
    title: "Trim & Crop Images Free",
  };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/crop_image", title: "Crop Image Online" },
    data2: { link: "/crop_image", title: "Image Cropper Free" },
    data3: { link: "/crop_image", title: "Trim Images Free" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length,
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Crop images online easily. Trim photos, cut images, and adjust dimensions quickly with our fast, secure, and easy-to-use image crop tool."
      ></meta>
      <meta
        name="keywords"
        content="crop image, crop images online, image cropper, crop photo, photo cropper, cut image online, trim image, image cropping tool, online image cropper, crop pictures, image editor online, crop image free, adjust image size, crop image tool, photo editing online"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <CropImageListImagesScreen title={title}></CropImageListImagesScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={false}
            filetype={{
              "image/jpeg": [".jpg", ".jpeg"],
              "image/png": [".png"],
              "image/webp": [".webp"],
              "image/bmp": [".bmp"],
              "image/svg+sml": [".svg"],
            }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our crop image website makes it easy to edit photos by removing unwanted areas and focusing on what matters most. With a powerful crop image online tool, users can quickly adjust image dimensions, improve composition, and prepare photos for websites, social media, documents, and presentations. This online image cropper allows you to precisely crop images without installing heavy software, making it ideal for beginners, professionals, and everyday users. Whether you want to trim image online for profile pictures, resize product photos for e-commerce, or adjust visuals for marketing creatives, a crop image tool delivers fast and accurate results. Modern image cropping tools support popular formats like JPG, PNG, and WebP while preserving original image quality. Using a crop image online solution saves time, works across devices, and ensures privacy by processing images securely. From designers and content creators to students and businesses, an online image cropper is an essential photo editing solution for clean, professional, and perfectly sized images." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Crop",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Crop Image Tool"
            why_use={[
              {
                title: "Remove Unwanted Areas from Images",
                description:
                  "Our crop image tool helps remove unnecessary parts of photos to focus on the main subject. Using crop image online or an image cropper improves clarity and visual appeal.",
              },
              {
                title: "Improve Image Composition and Framing",
                description:
                  "Cropping images allows better framing and balance, making photos look more professional for websites, blogs, and social media using a crop image online tool.",
              },
              {
                title: "Perfect for Social Media and Profile Photos",
                description:
                  "Our image cropper makes it easy to trim image online for profile pictures, cover photos, and posts that meet platform size requirements.",
              },
              {
                title: "Prepare Images for Websites and SEO",
                description:
                  "Using a crop image online tool helps optimize images for faster loading and better layout, improving user experience and SEO performance.",
              },
              {
                title: "Quick and Easy Image Editing",
                description:
                  "Our crop image tool allows instant editing without complex software, making image cropping fast, simple, and beginner-friendly.",
              },
              {
                title: "Resize and Trim Images for Any Use Case",
                description:
                  "With an image cropper, users can trim image online for documents, presentations, e-commerce product photos, and marketing materials.",
              },
              {
                title: "Maintain Image Quality While Cropping",
                description:
                  "Modern crop image online tools preserve resolution and clarity, ensuring high-quality results even after trimming images.",
              },
              {
                title: "Supports Multiple Image Formats",
                description:
                  "Our online image cropper supports JPG, PNG, WebP, and other popular formats, making it easy to crop images of any type.",
              },
              {
                title: "Works Across Devices Without Installation",
                description:
                  "Crop image online tools work on desktop and mobile browsers without downloads, offering flexibility and convenience.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1071677375}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default CropImagesMain;
